<div>
  <div class="dialog-body">
    <div class="dialog-content-description gea-font-body-20">
      Are you sure you want to undo changes to <strong>{{ asset.fileName }}</strong
      >?
    </div>
    <p class="dialog-warning">
      This will revert the file to its last published state. If the file has not been published yet, it will be removed. This
      action cannot be undone.
    </p>
  </div>
  <div class="p-dialog-footer">
    <geaui-button-v3 (click)="cancel()" type="secondary">Cancel</geaui-button-v3>
    <geaui-button-v3 (click)="confirm()" information="error">Undo changes</geaui-button-v3>
  </div>
</div>
